export class SetDeliveryTaskFailed {
    public orderID: number;
    public taskID: string;
    public reason: string;
}
